import { render, staticRenderFns } from "./Ruang.vue?vue&type=template&id=6d3a9a67"
import script from "./Ruang.vue?vue&type=script&lang=js"
export * from "./Ruang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports